<section class="nav-header my-10">
  <div class="inline-block">
    <h1 class="font-size-36 title">{{ dataSignal().pageTitle }}</h1>
    <p>{{ dataSignal().pageSubTitle ? dataSignal().pageSubTitle : '' }}</p>
  </div>
  <nav>
    @for (item of dataSignal().subTitles; track $index; let i = $index; let last = $last;) {
    <a
      class="font-size-14 text-ellipsis"
      [ngClass]="{ 'cursor-pointer': !last && !!!item.unUsePointer }"
      (click)="onClickPathUrl(item.partName, last)"
      (keydown.enter)="onClickPathUrl(item.partName, last)"
      tabindex="0"
    >
      {{ item.title }}
    </a>
    @if (!last) {
    <a class="font-size-14">&gt;</a>
    } }
  </nav>
</section>
